<template>
    <div class="nav-tab-bar" :class="{ 'none': navtablist.length == 0 }">
        <div class="nav-tab-item" :class="{ 'actived': item.path == nowpath }" @click="navPath(item)"
            v-for="(item, index) in navtablist" :key="index">
            <div class="corner left"></div>
            <div class="corner right"></div>
            <div class="content">
                <div class="title">{{ item.name }}</div>
                <div class="close-btn" @click.stop="closeNavTab(index)"><local-svg iconClass="close1"></local-svg></div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>
 
<script>
export default {
    name: 'NavTabBar',
    data() {
        return {

        }
    },
    computed: {
        navtablist: function() {
            return this.$store.state.navtablist
        },
        nowpath: function() {
            return this.$route.path
        },
    },
    methods: {
        navPath(obj) {
            this.$router.push({
                path: obj.path,
                query:{
                  q: obj.time,  
                }
            })
        },
        closeNavTab(index) {
            let data = JSON.parse(JSON.stringify(this.navtablist))
            data.splice(index, 1)
            this.$store.commit('setNavTab', data)
        }
    }
}
</script>
 
<style scoped lang="scss">
.nav-tab-bar {
    height: 100%;
    width: 100%;
    background: #ECF1F9;
    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #FFFFFF;
    display: flex;
    position: relative;
    overflow: auto;
    scrollbar-width: none;
    box-sizing: border-box;
    padding-right: 20px;
    &::-webkit-scrollbar{
        display: none;
    }

    &.none {
        border-bottom-color: #ECF1F9;
    }

    .nav-tab-item.actived:first-child .content {
        border-top-left-radius: 0;
    }

    .nav-tab-item {
        width: 8%;
        max-width: 134px;
        min-width: 70px;
        height: 100%;
        flex-shrink: 1;
        cursor: pointer;
        position: relative;

        .line {
            position: absolute;
            width: 1px;
            height: 16px;
            background: #D7DFEB;
            right: -0.5px;
            top: 50%;
            margin-top: -8px;
        }

        .content {
            height: 100%;
            width: 100%;
            font-weight: 400;
            font-size: 14px;
            color: #9A9EAA;
            line-height: 16px;
            padding: 0 5px 0 15px;
            background: transparent;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            position: absolute; //使flex-shrink生效

            .title {
                white-space: nowrap;
                overflow: hidden;
                mask-image: linear-gradient(90deg, #000 0%, #000 75%, #00000052 100%);
                flex: 1;
            }

            .close-btn {
                width: 16px;
                height: 16px;
                background: rgba(63, 69, 124, 0.1);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 8px;
                cursor: pointer;
                flex: none;
                display: none;

                .svg-icon {
                    width: 8px;
                    height: 8px;
                    color: #B0B1B9;
                }
            }
        }

        .corner {
            position: absolute;
            height: 6px;
            width: 12px;
        }

       .content .close-btn:hover {
            background: rgba(55, 96, 155, 0.2);

            .svg-icon {
                color: #5C8ACE;
            }
        }

        &.actived {
            z-index: 3;
            --bgcolor: #FFFFFF !important;

            .line {
                display: none;
            }

            .content {
                background: var(--bgcolor);
                padding: 0 8px 0 15px;
                color:#1D78FE;

                .close-btn {
                    display: flex;
                }
            }

            .corner.right {
                position: absolute;
                bottom: 0;
                right: -6px;
                background: var(--bgcolor);
                -webkit-mask: radial-gradient(circle at 100% 0%, transparent 6px, #fff 0);
                mask: radial-gradient(circle at 100% 0%, transparent 6px, #fff 0);
            }

            .corner.left {
                position: absolute;
                bottom: 0;
                left: -6px;
                background: var(--bgcolor);
                -webkit-mask: radial-gradient(circle at 0% 0%, transparent 6px, #fff 0);
                mask: radial-gradient(circle at 0% 0%, transparent 6px, #fff 0);
            }
        }


        &:hover {
            z-index: 1;
            --bgcolor: #E2EDFF;

            .line {
                display: none;
            }

            .content {
                background: var(--bgcolor);
                padding: 0 8px 0 15px;

                .close-btn {
                    display: flex;
                }
            }

            .corner.right {
                position: absolute;
                bottom: 0;
                right: -6px;
                background: var(--bgcolor);
                -webkit-mask: radial-gradient(circle at 100% 0%, transparent 6px, #fff 0);
                mask: radial-gradient(circle at 100% 0%, transparent 6px, #fff 0);
            }

            .corner.left {
                position: absolute;
                bottom: 0;
                left: -6px;
                background: var(--bgcolor);
                -webkit-mask: radial-gradient(circle at 0% 0%, transparent 6px, #fff 0);
                mask: radial-gradient(circle at 0% 0%, transparent 6px, #fff 0);
            }
        }
    }
}
</style>